jQuery(document).ready(function() {

// add class to hero on scroll

  if ($(this).scrollTop() >= 100) { // this refers to window
    $(".header-style-3-wrap").addClass("mod-nav");
  } else {
      $(".header-style-3-wrap").removeClass("mod-nav");
  }

  $(window).scroll(function() {
      if ($(this).scrollTop() >= 100) { // this refers to window
        $(".header-style-3-wrap").addClass("mod-nav");
      } else {
          $(".header-style-3-wrap").removeClass("mod-nav");
      }
  });

  // Scroll to ID

  $("#page-scroll").click(function() {
      $('html, body').animate({
          scrollTop: $("#scrollto").offset().top - 230,
      }, 1000);
  });

// AFFILIATE LOGO SLIDER

$('#nudgeCarousel').on('#nudgeCarousel slide.bs.carousel', function (e) {

    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 4;
    var totalItems = $('#nudgeCarousel .carousel-item').length;

    if (idx >= totalItems-(itemsPerSlide-1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction=="left") {
                $('#nudgeCarousel .carousel-item').eq(i).appendTo('#nudgeCarousel .carousel-inner');
            }
            else {
                $('#nudgeCarousel .carousel-item').eq(0).appendTo('#nudgeCarousel .carousel-inner');
            }
        }
    }
});

var myEle = document.getElementById("counter");
if(myEle){



$.fn.digits = function(){
    return this.each(function(){
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") );
    })
}

var a = 0;
$(window).ready(function() {

  var oTop = $('#counter').offset().top - window.innerHeight;
  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-value').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text(),
      }).animate({
          countNum: countTo,
        },

        {

          duration: 4000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum).digits();
          },

        });
    });
    a = 1;
  }

});

}

});



// WEBPACK FOOTER //
// ./scripts/mta.js